/**
 * Tour 3: Save & Manage — "Save, load, and organize your work"
 */

const TOUR_ID = "save-manage";

/** @param {{ t: (key: string, opts?: object) => string }} deps */
export function getSaveManageSteps({ t }) {
  return {
    id: TOUR_ID,
    label: t("Save & Manage", { defaultValue: "Save & Manage" }),
    description: t("Save, load, and organize your work", {
      defaultValue: "Save, load, and organize your work",
    }),
    steps: [
      {
        element: '[data-tour="action-submit"]',
        popover: {
          title: t("Save Topology", { defaultValue: "Save Topology" }),
          description: t(
            "Save your current topology with a name. The AI can generate a title and description for you.",
            {
              defaultValue:
                "Save your current topology with a name. The AI can generate a title and description for you.",
            },
          ),
          side: "bottom",
          align: "end",
        },
      },
      {
        element: '[data-tour="action-my-topologies"]',
        popover: {
          title: t("My Topologies", { defaultValue: "My Topologies" }),
          description: t(
            "Access all your saved topologies here. Click one to preview it or load it onto the canvas.",
            {
              defaultValue:
                "Access all your saved topologies here. Click one to preview it or load it onto the canvas.",
            },
          ),
          side: "bottom",
          align: "center",
        },
      },
      {
        element: '[data-tour="action-default-topologies"]',
        popover: {
          title: t("Default Templates", { defaultValue: "Default Templates" }),
          description: t(
            "Browse pre-built topology templates shared by administrators. Great starting points for common designs.",
            {
              defaultValue:
                "Browse pre-built topology templates shared by administrators. Great starting points for common designs.",
            },
          ),
          side: "bottom",
          align: "center",
        },
      },
      {
        element: '[data-tour="action-preview-json"]',
        popover: {
          title: t("Preview JSON", { defaultValue: "Preview JSON" }),
          description: t(
            "View your topology as raw JSON data. Copy it to the clipboard or use it for external tools.",
            {
              defaultValue:
                "View your topology as raw JSON data. Copy it to the clipboard or use it for external tools.",
            },
          ),
          side: "bottom",
          align: "start",
        },
      },
      {
        element: '[data-tour="action-import"]',
        popover: {
          title: t("Import", { defaultValue: "Import" }),
          description: t(
            "Import a topology from a JSON file or a screenshot. The AI converts it to an editable canvas format.",
            {
              defaultValue:
                "Import a topology from a JSON file or a screenshot. The AI converts it to an editable canvas format.",
            },
          ),
          side: "bottom",
          align: "start",
        },
      },
      {
        element: '[data-tour="action-sync"]',
        popover: {
          title: t("Sync Topology", { defaultValue: "Sync Topology" }),
          description: t(
            "Manually sync your canvas with the AI's state. Useful after making manual drag-and-drop changes.",
            {
              defaultValue:
                "Manually sync your canvas with the AI's state. Useful after making manual drag-and-drop changes.",
            },
          ),
          side: "bottom",
          align: "center",
        },
      },
    ],
  };
}

export default getSaveManageSteps;
